import { createSelector } from 'reselect';

export const urlSelector = createSelector(
  (state, props) => props.params.appId,
  (state, props) => props.params.restaurantId,
  (state, props) => props.params.orderType,
  (state, props) => props.params.orderDate,
  (state, props) => props.params.bookingDate,
  (appId, restaurantId, orderType, orderDate, bookingDate) => {
    return {
      appId,
      restaurantId,
      orderType,
      orderDate,
      bookingDate,
    };
  },
);



// WEBPACK FOOTER //
// ./src/selectors/urlSelectors.js